/**
 * KIKOMO — Volume Pricing JS
 * Archivo: assets/kikomo-volume-pricing.js
 *
 * Funciona con Dawn 15.x
 * Escucha cambios en el input de cantidad y actualiza:
 *   - La fila activa en la tabla de precios
 *   - El precio por pieza mostrado
 *   - El total estimado
 */

(function () {
  'use strict';

  function initVolumePricing() {
    const vp = document.querySelector('.kikomo-volume-pricing');
    if (!vp) return;

    // Leer tiers desde los data attributes del snippet
    const tiers = [
      {
        key: 'a',
        qty: parseInt(vp.dataset.qtyA, 10),
        price: parseFloat(vp.dataset.priceA),
      },
      {
        key: 'b',
        qty: parseInt(vp.dataset.qtyB, 10) || Infinity,
        price: parseFloat(vp.dataset.priceB),
      },
      {
        key: 'c',
        qty: parseInt(vp.dataset.qtyC, 10) || Infinity,
        price: parseFloat(vp.dataset.priceC),
      },
    ].filter((t) => !isNaN(t.qty) && !isNaN(t.price) && isFinite(t.qty) || t.key === 'a');

    const rows      = vp.querySelectorAll('.kikomo-vp__row');
    const priceEl   = document.getElementById('kikomo-active-price');
    const totalEl   = document.getElementById('kikomo-active-total');

    // Busca el input de cantidad en la página de producto (Dawn estándar)
    function getQtyInput() {
      return (
        document.querySelector('.product-form__input input[type="number"]') ||
        document.querySelector('input[name="quantity"]') ||
        document.querySelector('.quantity__input')
      );
    }

    function getActiveTier(qty) {
      // Recorre de mayor a menor para encontrar el tier que aplica
      const sorted = [...tiers].sort((a, b) => b.qty - a.qty);
      for (const tier of sorted) {
        if (qty >= tier.qty) return tier;
      }
      return tiers[0];
    }

    function fmt(n) {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2,
      }).format(n);
    }

    function update(qty) {
      qty = parseInt(qty, 10);
      if (isNaN(qty) || qty < 1) qty = 1;

      const active = getActiveTier(qty);

      // Resaltar fila activa
      rows.forEach((row) => {
        row.classList.toggle(
          'kikomo-vp__row--active',
          row.dataset.tier === active.key
        );
      });

      // Actualizar precio por pieza
      if (priceEl) {
        priceEl.textContent = fmt(active.price) + ' / pza';
      }

      // Actualizar total
      if (totalEl) {
        const total = active.price * qty;
        totalEl.textContent = `= ${fmt(total)} total (${qty} pza)`;
      }

      // También actualizamos el precio principal de Dawn si existe
      // Dawn usa el elemento .price__sale o .price-item--sale
      const mainPrice = document.querySelector(
        '.price-item--sale, .price-item--regular'
      );
      if (mainPrice && active.key !== 'a') {
        mainPrice.setAttribute('data-kikomo-price', mainPrice.textContent);
        // Solo actualiza el display, NO el precio real del carrito
        // El precio real se maneja via Discount Scripts o en el checkout
      }
    }

    // Observar cambios en el input de cantidad
    function attachListener() {
      const qtyInput = getQtyInput();
      if (!qtyInput) {
        // Dawn carga el form después, reintenta
        setTimeout(attachListener, 500);
        return;
      }

      qtyInput.addEventListener('change', (e) => update(e.target.value));
      qtyInput.addEventListener('input',  (e) => update(e.target.value));

      // También capturar los botones +/- de Dawn
      const form = qtyInput.closest('form, .product-form, .quantity');
      if (form) {
        form.addEventListener('click', (e) => {
          if (
            e.target.matches('.quantity__button, [name="plus"], [name="minus"]')
          ) {
            setTimeout(() => update(qtyInput.value), 50);
          }
        });
      }

      // Inicializar con la cantidad actual
      update(qtyInput.value || 1);
    }

    attachListener();

    // Re-inicializar si Dawn cambia de variante (evento nativo de Shopify)
    document.addEventListener('variant:change', () => {
      setTimeout(() => {
        const qtyInput = getQtyInput();
        if (qtyInput) update(qtyInput.value || 1);
      }, 100);
    });
  }

  // Esperar a que el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVolumePricing);
  } else {
    initVolumePricing();
  }
})();
